import { render, staticRenderFns } from "./SickLeaveCreationModal.vue?vue&type=template&id=cc841874&scoped=true&"
import script from "./SickLeaveCreationModal.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc841874",
  null
  
)

export default component.exports